import React, { useId } from 'react';

import { FieldSet, FormHelp, Heading, Label, LabeledControl, Legend, Radio } from '@zillow/constellation-10';

import type { Section } from '../../../models';
import { PROPERTY_CONDITION_CHECKLIST_OPTIONS } from '../../../constants';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function PropertyConditionChecklistOptions({ section, setSectionValues }: Props) {
  const radioGroupName = useId();
  const attachBlankId = useId();
  const uploadOwnId = useId();

  function onAttachBlankChecklistSelect(): void {
    setSectionValues({
      [PROPERTY_CONDITION_CHECKLIST_OPTIONS.FIELD_NAME.UPLOAD_OWN]: false,
      [PROPERTY_CONDITION_CHECKLIST_OPTIONS.FIELD_NAME.ATTACH_BLANK]: true,
    });
  }

  function onUploadMyOwnSelect(): void {
    setSectionValues({
      [PROPERTY_CONDITION_CHECKLIST_OPTIONS.FIELD_NAME.UPLOAD_OWN]: true,
      [PROPERTY_CONDITION_CHECKLIST_OPTIONS.FIELD_NAME.ATTACH_BLANK]: false,
    });
  }

  return (
    <>
      <Heading level={3} textStyle="responsive.heading-xs" css={{ marginBottom: 'layout.tight' }}>
        Move-in property condition checklist
      </Heading>
      <FieldSet
        required
        legend={
          <Legend>
            Would you like us to attach a blank checklist to the lease, or would you like to upload your own?
          </Legend>
        }
        description={
          <FormHelp>
            Use a move-in property condition checklist to inventory any existing damage to your property
          </FormHelp>
        }
      >
        <LabeledControl
          controlId={attachBlankId}
          label={<Label>Attach blank checklist to the lease</Label>}
          control={
            <Radio
              name={radioGroupName}
              checked={section.getFieldValue(PROPERTY_CONDITION_CHECKLIST_OPTIONS.FIELD_NAME.ATTACH_BLANK)}
              onChange={onAttachBlankChecklistSelect}
            />
          }
        />
        <LabeledControl
          controlId={uploadOwnId}
          label={<Label>Upload my own</Label>}
          control={
            <Radio
              name={radioGroupName}
              checked={section.getFieldValue(PROPERTY_CONDITION_CHECKLIST_OPTIONS.FIELD_NAME.UPLOAD_OWN)}
              onChange={onUploadMyOwnSelect}
            />
          }
        />
      </FieldSet>
    </>
  );
}

export default PropertyConditionChecklistOptions;
